export default "__VITE_ASSET__OZy76KB2__"